import { NAV_LINKS } from '@/mocks/anime';

export default function Footer() {
  const categories = ['热血冒险', '奇幻异界', '恋爱日常', '治愈系', '科幻机甲', '悬疑推理', '搞笑喜剧', '运动竞技'];

  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4 md:gap-8">
          {/* 品牌 */}
          <div className="md:col-span-2">
            <a href="#home" className="flex items-center gap-2.5 whitespace-nowrap">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500 text-background-50">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <span className="font-heading text-xl text-background-50">卡通动漫第一页</span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-7 text-background-100/80">
              一站式动漫追更入口导航，汇聚热门作品、新番连载与主题分类。入口清晰、打开即看，收藏本站随时追更不迷路。
            </p>
            <div className="mt-5 flex items-center gap-2 text-xs text-background-100/70">
              <i className="ri-verified-badge-fill text-secondary-400"></i>
              想看动漫不迷路，直接进卡通动漫第一页
            </div>
          </div>

          {/* 快速导航 */}
          <div>
            <h4 className="font-heading text-sm text-background-50">快速导航</h4>
            <ul className="mt-4 space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <a href={`#${l.id}`} className="text-sm text-background-100/80 transition-colors hover:text-secondary-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 主题分类 */}
          <div>
            <h4 className="font-heading text-sm text-background-50">主题分类</h4>
            <ul className="mt-4 flex flex-wrap gap-x-3 gap-y-2.5">
              {categories.map((c) => (
                <li key={c}>
                  <a href="#category" className="text-sm text-background-100/80 transition-colors hover:text-secondary-300 whitespace-nowrap">
                    {c}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* 版权条 */}
      <div className="border-t border-background-800">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-4 py-5 sm:flex-row md:px-6">
          <p className="text-xs text-background-100/60">© 2026 卡通动漫第一页 · 动漫爱好者的一站式追更入口</p>
          <div className="flex items-center gap-4">
            <a href="#contact" className="text-xs text-background-100/60 transition-colors hover:text-secondary-300 whitespace-nowrap">联系我们</a>
            <a href="#faq" className="text-xs text-background-100/60 transition-colors hover:text-secondary-300 whitespace-nowrap">常见问题</a>
            <button
              type="button"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
              aria-label="回到顶部"
            >
              <i className="ri-arrow-up-line"></i>
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}